import { Component, EventEmitter, Inject, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { FeedItem } from '../../models/feed-item.model';
import { SvcCommentsFeedComponent } from '../svc-comments-feed/svc-comments-feed.component';
import { SvcCommentsChatComponent } from '../svc-comments-chat/svc-comments-chat.component';
import { SvcComment } from '../../models/comment.model';

@Component({
  selector: 'svc-comments-viewer',
  templateUrl: './svc-comments-viewer.component.html',
  styleUrls: ['./svc-comments-viewer.component.scss'],
})
export class SvcCommentsViewerComponent {
  @ViewChild('svcCommentsChat') public svcCommentsChat!: SvcCommentsChatComponent;

  @Input() selectedFeed: FeedItem;

  @Output() public onCommentAdded = new EventEmitter<SvcComment>();

  constructor(@Inject(forwardRef(() => SvcCommentsFeedComponent)) public parent: SvcCommentsFeedComponent) {}

  public tryToRefreshChatByCommentId(commentId: number) {
    this.svcCommentsChat?.tryToUpdateFromCommentId(commentId);
  }

  public openFeedModule() {
    this.parent.openSelectedFeedModule();
  }
}
